<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="8">
              <form-item label="姓名" prop="userName">
                <Input
                  v-model="query.userName"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>

            <i-col span="8">
              <form-item label="派驻类别">
                <Cascader
                  v-model="partyTypeValue"
                  :data="partyTypeList"
                  placeholder="请选择"
                  clearable
                  @on-change="partyTypeChange"
                  change-on-select
                ></Cascader>
              </form-item>
            </i-col>
            <i-col span="8">
              <form-item label="评价月">
                <DatePicker
                  type="month"
                  v-model="query.recordDate"
                  placeholder="请选择"
                  class="w-100"
                  @on-change="dateChangeHandler"
                ></DatePicker>
              </form-item>
            </i-col>
            <i-col span="8">
              <form-item label="服务企业">
                <Input
                  v-model="query.companyNames"
                  clearable
                  placeholder="请输入"
                />
              </form-item>
            </i-col>
            <i-col span="8">
              <form-item label="自评结果">
                <Select v-model="query.grade" clearable>
                  <Option
                    v-for="item in statusList"
                    :key="item.index"
                    :value="item.index"
                    :label="item.status"
                  ></Option>
                </Select>
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div>
      <div class="table-wrapper">
        <i-table
          :columns="monthTableHeader"
          :border="true"
          :loading="isTableLoading"
          :data="tableData"
          stripe
        >
          <template slot-scope="{ row }" slot="party_type_list">
            <span v-if="row.party_type_list">
              {{ partyTypeName(row.party_type_list) }}
            </span>
            <span v-if="!row.party_type_list">
              {{ partyTypeName(row.partyType) }}
            </span>
          </template>
          <template slot-scope="{ row }" slot="grade">
            <span v-if="row.grade === 1" class="fine-color">优秀</span>
            <span v-if="row.grade === 2" class="qualify-color">称职</span>
            <span v-if="row.grade === 3" class="not-qualify-color">不称职</span>
          </template>
          <template slot-scope="{ row }" slot="recordDate">
            {{ row.recordDate.substring(0, 7) }}
          </template>
        </i-table>
        <div class="page">
          <page
            :total="total"
            :current="pageNum"
            @on-change="pageChange"
            show-total
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { postEvaluateStatistic, exportSelfStatisticsExcel } = api;
import { getPartyTypeDic, getQuestionTypeDic, getCompanyTypeDic } from "./dic";
export default {
  name: "evaluateStatistic",
  components: {
    pageHead
  },
  data() {
    return {
      partyTypeValue: [],
      partyTypeList: [],
      companyTypeList: [],
      title: "自评统计",
      btnList: [
        {
          name: "搜索",
          type: "search"
        },
        {
          name: "重置",
          type: "reset"
        },
        {
          name: "导出",
          type: "export"
        }
      ],
      query: {
        userName: "",
        partyType: null,
        recordDate: "",
        companyNames: "",
        grade: ""
      },
      pageNum: 1,
      pageSize: 10,
      total: 0,
      info: {},
      statusList: [
        {
          index: 1,
          status: "优秀"
        },
        {
          index: 2,
          status: "称职"
        },
        {
          index: 3,
          status: "不称职"
        }
      ],
      isTableLoading: false,
      monthTableHeader: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center"
        },
        {
          title: "姓名",
          key: "userName"
        },
        {
          title: "联系电话",
          key: "phoneNO"
        },
        {
          title: "派驻类别",
          slot: "party_type_list"
        },
        {
          title: "评价月",
          slot: "recordDate"
        },
        {
          title: "服务企业",
          key: "companyNames"
        },
        {
          title: "自评结果",
          slot: "grade"
        }
      ],
      tableData: [],
      header: {
        token: window.sessionStorage.getItem("token")
      }
    };
  },
  computed: {
    partyTypeName() {
      return function(type) {
        const levelArr = type.split(",");
        let name = "";
        this.partyTypeList.filter(item => {
          if (item.value === levelArr[0]) {
            name = item.label;
            if (levelArr[1] && item.children) {
              item.children.filter(inner => {
                if (inner.value === levelArr[1]) {
                  name = name + "/" + inner.label;
                }
              });
            }
          }
          return;
        });
        // console.log("看看处理后的数据：", name);
        return name;
      };
    }
  },
  methods: {
    // 搜索 重置 导出逻辑
    handleBtn(type) {
      const handler = this[type + "Handler"];
      handler && handler();
    },
    // 重置处理
    resetHandler() {
      this.pageNum = 1;
      this.query.userName = "";
      this.query.partyType = null;
      this.query.recordDate = "";
      this.query.companyNames = "";
      this.query.grade = "";
      this.partyTypeValue = [];
      this.$refs.search.resetFields();
      this.getList();
    },
    // 搜索处理
    searchHandler() {
      this.pageNum = 1;
      this.getList();
    },
    // 导出处理
    exportHandler() {
      let { userName, partyType = null, companyNames, grade, recordDate } = this.query;
      const url = `${exportSelfStatisticsExcel}?userName=${userName}&partyType=${partyType}&companyNames=${companyNames}&grade=${grade}&recordDate=${recordDate}&token=${
        this.header.token
      }`;
      // console.log(url);
      window.open(url);
    },
    // 日期发生变化
    dateChangeHandler(date) {
      this.query.recordDate = date;
    },
    // 分页变更获取相关数据
    pageChange(val) {
      this.pageNum = val;
      this.getList();
    },
    // 驻派类别变更时
    partyTypeChange(value) {
      let returndata = value[value.length - 1];
      // console.log("驻派类别数据发生变化 ", returndata);
      this.query.partyType = returndata;
    },
    // 获取工作记实
    async getList() {
      const d = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        ...this.query
      };
      // console.log("看看传入的参数   ", d);
      let res = await this.$post(postEvaluateStatistic, d);
      // console.log(this.query);
      // console.log("看看自评统计数据 ", res.rows);
      this.tableData = res.rows;
      this.total = res.total || 0;
    },
    // 获取问题类别
    async getQuestionTypeList() {
      const res = await this.$get(getQuestionTypeDic);
      if (res.isSucceed) {
        this.questionTypeList = res.rows.length ? res.rows : [];
      }
    },
    // 获取企业类型
    async getCompanyTypeList() {
      const res = await this.$get(getCompanyTypeDic);
      // console.log(res.rows);
      this.companyTypeList = res.rows || [];
    },
    // 获取驻派类别
    async getPartyTypeList() {
      const res = await this.$get(getPartyTypeDic);
      this.partyTypeList = res.rows.length ? this.formateData(res.rows) : [];
      // console.log("查看驻派类别数据：", this.partyTypeList);
    },
    // 格式化驻派类别数据
    formateData(data) {
      let returnData = data.map(item => {
        return {
          value: item.dicType,
          label: item.dicName,
          children: item.children.length ? this.formateData(item.children) : []
        };
      });
      return returnData;
    }
  },
  created() {
    this.getPartyTypeList();
    this.getQuestionTypeList();
    this.getCompanyTypeList();
    this.getList();
  }
};
</script>

<style lang="less" scoped>
.w-100 {
  width: 100%;
}
.fine-color {
  color: #47ba54;
}
.qualify-color {
  color: #00a0ea;
}
.commonly-color {
  color: #ff7b44;
}
.not-qualify-color {
  color: #ee5e51;
}
.content {
  margin: 20px;
}
.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}
.table-wrapper {
  height: 100%;
  position: relative;
  padding: 20px 20px 80px;
  background-color: #fff;
}
.page {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.table-head-btn {
  margin-left: auto;
  width: fit-content;
  margin-bottom: 20px;
}
.action {
  margin: 0 5px;
}
.model-title {
  color: #ff7b44;
  font-weight: bold;
}

.model-num {
  color: #ff7b44;
  font-weight: 400;
  background: #ffefe9;
  margin: 0 15px 10px 0;
}
</style>
